import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { bytesToView } from '@helpers';

import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default ({ C, name, data }) => {
  const proggress = 100 - (data.fileSizeRemaining * 100) / (data.fileSizeCompleted + data.fileSizeRemaining);
  return (
    <View style={[getBoxShadowStyle({ type: 'Field', C }), { borderRadius: scale(SCREEN_BORDER_RADIUS), flex: 1 }]}>
      <View
        style={{
          height: scale(120),
          width: '100%',
          backgroundColor: C('Background/Light/Field'),
          borderRadius: scale(SCREEN_BORDER_RADIUS),
          paddingHorizontal: scale(14),
        }}
      >
        <Text style={[font['Headline Large'], { color: C('Label/Light/Primary'), marginTop: scale(15) }]} numberOfLines={1}>
          {name}
        </Text>
        <View style={{ width: '100%', marginTop: scale(18) }}>
          <View style={{ backgroundColor: C('Background/Light/Chart'), height: scale(2), width: '100%', borderRadius: scale(2), overflow: 'hidden' }}>
            <View style={{ width: `${proggress}%`, height: '100%', backgroundColor: C('Label/Light/Primary') }} />
          </View>
        </View>
        <View style={{ width: '100%', marginTop: scale(4), justifyContent: 'space-between', flexDirection: 'row' }}>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Primary') }]}>{bytesToView(data.fileSizeCompleted)}</Text>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{bytesToView(data.fileSizeRemaining)} remaining</Text>
        </View>
        <View style={{ width: '100%', marginTop: scale(6), justifyContent: 'space-between', flexDirection: 'row' }}>
          <Text style={[font['Caption 1'], { color: C('Label/Light/Primary') }]}>
            {data.fileCountCompleted} {i18n.t('files')}
          </Text>
          <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>
            {data.fileCountRemaining} {i18n.t('files remaining')}
          </Text>
        </View>
      </View>
    </View>
  );
};
